import script from "./EncuestaModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EncuestaModal.vue?vue&type=script&setup=true&lang=ts"

import "./EncuestaModal.vue?vue&type=style&index=0&id=9ec1a2ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ec1a2ac"]])

export default __exports__